// 权限管理
import router from "@/router/index";
import eventBus from "@/utils/bus";
import { Message } from "element-ui";
import { UserModule } from "@/store/module/user";
import { RouterModule } from "@/store/module/router";
import { PageModule } from "@/store/module/page";
import { adminLogin } from "@/api/staff";
import store from "./store";

const whiteList = ["/login"];

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("token");
  const { path } = to;
  const isWhite = whiteList.indexOf(path) !== -1;
  // 超管登录
  if (to.query.tssalt) {
    const res: any = await adminLogin({
      bg_token: to.query.tssalt,
    });
    if (res.error_code === 0) {
      Message.success("超管登录成功，进入首页");
      // 通知其他超管页面
      const channel = new BroadcastChannel("mwow-page-channels");
      channel.postMessage("super-new-login");
      UserModule.SET_TOKEN(res.data.token);
      await UserModule.updateUserInfo();
      router.push({ name: "dashboard" });
    } else {
      Message.error("超管登录失败" + res.message);
      return next("/login");
    }
    return next();
  }

  if (token) {
    // 判断用户信息完整性
    const userInfo = UserModule.userInfo.staff_id;
    if (!userInfo) {
      await UserModule.updateUserInfo();
    }
    // 检查用户菜单是否已加载
    if (RouterModule.asyncRouters.length === 0) {
      await RouterModule.SetAsyncRouter();
      const asyncRouters = RouterModule.asyncRouters;
      router.addRoutes(asyncRouters);
      return next({ ...to, replace: true });
    }
    if (path === "/login") {
      Message.success("已登录，进入首页");
      return next("/layout");
    }
    if (path === "/") {
      return next("/layout/404");
    }
    // 积分禁止路由
    if (UserModule.userInfo.integral_switch === 2) {
      if (
        to.name === "integralLog" ||
        to.name === "integralGoods" ||
        to.name === "integralGoodsDetail" ||
        to.name === "integralExchange"
      ) {
        Message.warning("请开启积分功能后访问");
        return next("/layout");
      }
    }
    return next();
  } else {
    if (!isWhite) {
      Message.warning("未登录，请先登录");
      return next("/login");
    }
    return next();
  }
});

// 路由后
router.afterEach((to: any, from: any) => {
  PageModule.SET_LATEST_ROUTE(from.name);
  eventBus.$emit("layout-scroll-top");
});
